import React from "react";
import { useFormContext } from "react-hook-form";
import NumberValue, { NumberValueProps } from "../NumberValue/NumberValue";

function PercentValue(props: NumberValueProps) {
  const { type, prefixName } = props;
  const { trigger } = useFormContext();
  const name =
    type === "number[]"
      ? `${prefixName}.value.value[0]`
      : `${prefixName}.value.value`;

  const validatePercent = (value?: any) => {
    if (typeof value === "number" && !isNaN(value)) {
      if (hasMoreThanOneDecimal(value)) {
        return "Please enter a number with at most 1 decimal place";
      }
    }
  };

  const hasMoreThanOneDecimal = (value: number) => {
    return !Number.isInteger(value * 10);
  };

  React.useEffect(() => {
    trigger([name]);
  }, [trigger, name]);

  return (
    <NumberValue
      {...props}
      placeholder="Percentage"
      min={0.1}
      max={100}
      validate={validatePercent}
    />
  );
}

export default PercentValue;
